class MyMap {
	constructor(element, options) {
		this.map = new ymaps.Map(element, {
			center: options.center,
			controls: options.controls || [],
			zoom: options.zoom || 15,
		}, {
			suppressMapOpenBlock: options.suppressMapOpenBlock || true,
		});
	}

	createPlacemark = (data) => {
		const placemark = new ymaps.Placemark(data.coords, this.getPlacemarkProperties(data), this.getPlacemarkOptions());

		placemark.events.add('balloonopen', (e) => {
			placemark.properties.set({
				iconImageHref: '#map-pin-active',
			})
		})

		placemark.events.add('balloonclose', (e) => {
			placemark.properties.set({
				iconImageHref: '#map-pin-passive',
			})
		})

		return placemark;
	}

	getPlacemarkLayout = () => {
		return ymaps.templateLayoutFactory.createClass(this.placemarkLayout || `
			<div class="placemark">
				<div class="placemark__content">
					<div class="placemark__icon">
						<svg viewBox="0 0 60 60" width="60" height="60">
							<use xlink:href="{{properties.iconImageHref}}"></use>
						</svg>
					</div>
				</div>
			</div>
		`);
	}

	getBalloonLayout = () => {
		return ymaps.templateLayoutFactory.createClass(this.balloonLayout || `
				<div class="balloon{% if properties.state.selectedStoreID == properties.id %} active{% endif %}">
					<div class="balloon__wrapper">
						<div class="balloon__close js-balloon-close">
							<svg viewBox="0 0 24 24" width="24" height="24">
								<use xlink:href="#close"></use>
							</svg>
						</div>
						<div class="balloon__content">
							<h3 class="balloon__content-address">{{properties.address}}</h3>
							<div class="balloon__content-info">
								<p>Срок хранения заказа: {{properties.storage}}</p>
								<p>Будет готов к отгрузке: {{properties.receiving}}</p>
							</div>
							<footer class="balloon__footer">
								<button class="balloon__button-select">{% if properties.state.selectedStoreID == properties.id %}Выбран{% else %}Выбрать{% endif %}</button>
							</footer>
						</div>
					</div>
					<div class="balloon__tail"></div>
				</div>
			`, this.balloonLayoutConfig || {
                build: function() {
                    this.constructor.superclass.build.call(this);

                    this._element = this.getElement().querySelector('.balloon');

                    this.applyElementOffset();

                    this._element.querySelector('.js-balloon-close').addEventListener('click', this.onCloseClick.bind(this));
                    this._element.querySelector('.balloon__button-select').addEventListener('click', this.onSelectClick.bind(this));
                },


                clear: function() {
                    this._element.querySelector('.js-balloon-close').removeEventListener('click', this.onCloseClick)
                    this._element.querySelector('.balloon__button-select').removeEventListener('click', this.onSelectClick.bind(this));

                    this.constructor.superclass.clear.call(this);
                },

                onSublayoutSizeChange: function() {
                    this.constructor.superclass.onSublayoutSizeChange.apply(this, arguments);

                    if(!this._element) return;

                    this.applyElementOffset();

                    this.events.fire('shapechange');
                },

                applyElementOffset: function() {
                    this._element.style.cssText = `
                        left: -${this._element.offsetWidth / 2}px;
                        top: -${this._element.offsetHeight + 30}px;
                    `
                },

                onCloseClick: function(e) {
                    e.preventDefault();

                    this.events.fire('userclose');
                },

                onSelectClick: function(e) {
                    e.preventDefault();

                    state.selectedStoreID = this._data.properties.get('id');
                    updateSelectedStore();
                    changeStoreID(this._element);
                    modals.closeModal(null, '#store-selection')
                },

                getShape: function () {
                    if(!this._element) {
                        return this.constructor.superclass.getShape.call(this);
                    }

                    return new ymaps.shape.Rectangle(new ymaps.geometry.pixel.Rectangle([
                        [this._element.offsetLeft, this._element.offsetTop],
                        [
                            this._element.offsetLeft + this._element.offsetWidth,
                            this._element.offsetTop + this._element.offsetHeight,
                        ]
                    ]));
                },
		})
	}

	getBalloonPanelLayout = () => {
		return  ymaps.templateLayoutFactory.createClass(`
			<div class="balloon balloon__panel{% if properties.state.selectedStoreID == properties.id %} active{% endif %}">
				<div class="balloon__wrapper">
					<div class="balloon__close js-balloon-close">
						<svg viewBox="0 0 24 24" width="24" height="24">
							<use xlink:href="#close"></use>
						</svg>
					</div>
					<div class="balloon__content">
						<h3 class="balloon__content-address">{{properties.address}}</h3>
						<div class="balloon__content-info">
							<p>Срок хранения заказа: {{properties.storage}}</p>
							<p>Будет готов к отгрузке: {{properties.receiving}}</p>
						</div>
						<footer class="balloon__footer">
							<button class="balloon__button-select">{% if properties.state.selectedStoreID == properties.id %}Выбран{% else %}Выбрать{% endif %}</button>
						</footer>
					</div>
				</div>
			</div>
		`, {
            build: function() {
                this.constructor.superclass.build.call(this);

                this._element = this.getElement().querySelector('.balloon');

                this._element.querySelector('.js-balloon-close').addEventListener('click', this.onCloseClick.bind(this));
                this._element.querySelector('.balloon__button-select').addEventListener('click', this.onSelectClick.bind(this));
            },


            clear: function() {
                this._element.querySelector('.js-balloon-close').removeEventListener('click', this.onCloseClick)
                this._element.querySelector('.balloon__button-select').removeEventListener('click', this.onSelectClick.bind(this));

                this.constructor.superclass.clear.call(this);
            },

            onCloseClick: function(e) {
                e.preventDefault();

                this.events.fire('userclose');
            },

            onSelectClick: function(e) {
                e.preventDefault();

                state.selectedStoreID = this._data.properties.get('id');
                changeStoreID(this._data.properties, this);
            },
        })
	}

	getPlacemarkProperties = (data) => {
		return this.placemarkProperties || {
			iconImageHref: '#map-pin-passive',
            state,
			...data,
		}
	}

	getPlacemarkOptions = () => {
		return this.placemarkOptions || {
			iconLayout: this.getPlacemarkLayout(),
			iconShape: {
				type: 'Circle',
				coordinates: [0, 0],
				radius: 30,
			},
			balloonLayout: this.getBalloonLayout(),
			balloonCloseButton: false,
			hideIconOnBalloonOpen: false,
            openEmptyBalloon: true,
			balloonPanelMaxMapArea: window.innerWidth < 768 ? Infinity : 0,
			balloonAutoPanMargin: window.innerWidth < 768 ? 0 : 12,
			balloonPanelContentLayout: this.getBalloonPanelLayout(),
		}
	}
}

function changeStoreID(balloon) {
    if (balloon) {
        const balloonBtn = balloon.querySelector('.balloon__button-select');

        balloon.classList.add('active');
        balloonBtn.textContent = 'Выбран';
    }

    const prevActiveListItem = document.querySelector(`[data-store-id].active`);
    const newActiveListItem = document.querySelector(`[data-store-id="${state.selectedStoreID}"]`);

    const triggerBtn = document.querySelector(`[href="#store-selection"]`);
    const blockForm = triggerBtn.closest('.order-form-block');
    const storeInfo = blockForm.querySelector('.page-order__itemSelection');

    if (prevActiveListItem) {
        const btn = prevActiveListItem.querySelector('.store-selection__item-btn');

        prevActiveListItem.classList.remove('active');
        btn.textContent = 'Выбрать';
    }

    if (newActiveListItem) {
        const btn = newActiveListItem.querySelector('.store-selection__item-btn');

        newActiveListItem.classList.add('active')
        btn.textContent = 'Выбран';
    }

    updateStoreSelectionInfo();

    storeInfo.classList.add('active')
}
